import AOS from 'aos';

export default {
  init() {
    // init aos when dom is ready
    $(function() {
      AOS.init({
        duration: 800,
        once: true, // whether animation should happen only once - while scrolling down
        anchorPlacement: 'top-bottom',
      })
    });

    // if modal is open, back button in browser should close it, not actually go back
    $(".modal").on("shown.bs.modal", function()  { // any time a modal is shown
      var urlReplace = "#" + $(this).attr('id'); // make the hash the id of the modal shown
      history.pushState(null, null, urlReplace); // push state that hash into the url
    });

    // If a pushstate has previously happened and the back button is clicked, hide any modals.
    $(window).on('popstate', function() {
      $(".modal").modal('hide');
    });

    // when the modal is closed, remove the hash
    $('.modal').on('hidden.bs.modal', function() {
      var hash = this.id;
      history.replaceState('', document.title, window.location.pathname);
    });

    // when close button clicked simulate back
    $('.modal button.close').on('click', function(){
      window.history.back();
    });

    // Handle stick to top functionality for nav
    if( $('.fix-on-scroll').length ) {
      var offset = $('.fix-on-scroll').offset().top;
      $(window).on('scroll', function(){
        $('.fix-on-scroll').toggleClass('fixed-to-top', ($(this).scrollTop()) > offset )
      });
    }
  },
  finalize() {
    // JavaScript to be fired on all pages, after page specific JS is fired
  },
};



// WEBPACK FOOTER //
// ./scripts/routes/common.js